import { useParams } from "react-router-dom";
import { useFetchTeamById, useFetchTeamPersons } from "../../../api/hooks";
import Header from "../../../uikit/Header/Header";
import TeamGrid from "../components/TeamProfilesGrid";

export default function TeamProfileListing() {
  const { id } = useParams();
  const { data: team } = useFetchTeamById(id);
  const { data: persons } = useFetchTeamPersons(id);

  return (
    <>
      <Header />
      <TeamGrid
        title={team?.fields.long_name || ""}
        callout={team?.fields.location || ""}
        people={
          persons?.map((person) => ({
            name: person.fields.full_name,
            role: person.fields.role,
            number: person.fields.number,
            imageUrl: person.fields.image?.[0]?.url,
          })) || []
        }
        backgroundImage={team?.fields.team_cover?.[0]?.url || ""}
      />
    </>
  );
}
